/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import { fromJS } from 'immutable';
import * as constants from 'data/constants/airspaces';
import LoadingProgress from 'data/utils/reducers/loading';

export const listLoadingProgress = new LoadingProgress('airspaceList');
export const airspaceOverviewLoadingProgress = new LoadingProgress('airspaceOverview');
export const audioSnippetsLoadingProgress = new LoadingProgress('audioSnippets');

const mergeData = (state, payload) =>
  state.withMutations((newState) => {
    const {
      entities: { airspaces },
    } = payload;
    newState.mergeIn(['entities'], fromJS(airspaces));
  });

const loadList = (state, action) =>
  state.withMutations((newState) => {
    mergeData(newState, action.payload);
    newState.set('list', fromJS(action.payload.result));
    listLoadingProgress.setLoaded(newState);
  });

const loadAirspaceOverview = (state, action) =>
  state.withMutations((newState) => {
    newState.set('airspaceOverview', fromJS(action.payload));
    airspaceOverviewLoadingProgress.setLoaded(newState);
  });

const clear = (state) =>
  state.withMutations((newState) => {
    listLoadingProgress.clear(newState);
    airspaceOverviewLoadingProgress.clear(newState);
  });

const clearAirspaceOverview = (state) =>
  state.withMutations((newState) => {
    newState.set('airspaceOverview', fromJS({}));
    airspaceOverviewLoadingProgress.clear(newState);
  });

const loadAudioSnippets = (state, action) =>
  state.withMutations((newState) => {
    newState.set('audioSnippets', fromJS(action.payload));
    audioSnippetsLoadingProgress.setLoaded(newState);
  });

const clearAudioSnippets = (state) =>
  state.withMutations((newState) => {
    newState.set('audioSnippets', fromJS([]));
    audioSnippetsLoadingProgress.clear(newState);
  });

const initialState = fromJS({
  entities: {},
  list: [],
  airspaceOverview: {},
  audioSnippets: [],
});

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.LIST_LOAD_START:
      return listLoadingProgress.setLoading(state);
    case constants.LIST_LOAD_FAILED:
      return listLoadingProgress.setLoadFailed(state);
    case constants.LIST_LOAD_SUCCESS:
      return loadList(state, action);
    case constants.AIRSPACE_OVERVIEW_LOAD_SUCCESS:
      return loadAirspaceOverview(state, action);
    case constants.AIRSPACE_OVERVIEW_LOAD_FAILED:
      return airspaceOverviewLoadingProgress.setLoadFailed(state);
    case constants.AIRSPACE_OVERVIEW_LOAD_START:
      return airspaceOverviewLoadingProgress.setLoading(state);

    case constants.AUDIO_SNIPPETS_LOAD_START:
      return audioSnippetsLoadingProgress.setLoading(state);
    case constants.AUDIO_SNIPPETS_LOAD_SUCCESS:
      return loadAudioSnippets(state, action);
    case constants.AUDIO_SNIPPETS_LOAD_FAILED:
      return audioSnippetsLoadingProgress.setLoadFailed(state);

    case constants.AUDIO_SNIPPETS_CLEAR:
      return clearAudioSnippets(state);

    case constants.CLEAR:
      return clear(state);
    case constants.CLEAR_AIRSPACE_OVERVIEW:
      return clearAirspaceOverview(state);

    default:
      return state;
  }
};
